import type { Comic } from '@/mocks/animeData';

interface ComicCardProps {
  comic: Comic;
  showScore?: boolean;
}

export default function ComicCard({ comic, showScore = true }: ComicCardProps) {
  return (
    <article
      className="group cursor-pointer overflow-hidden rounded-lg bg-background-100 border border-background-200 transition-colors duration-300 hover:border-primary-300"
      data-product-shop
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden">
        <img
          src={comic.image}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 最新章节 ${comic.chapter}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {showScore && (
          <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-full bg-background-950/70 px-2 py-1 text-xs font-bold text-secondary-400 backdrop-blur-sm">
            <i className="ri-star-fill"></i>
            {comic.score}
          </span>
        )}
        {comic.isNew && (
          <span className="absolute right-2 top-2 rounded-full bg-primary-500 px-2 py-1 text-xs font-bold text-background-50">
            新作
          </span>
        )}
        <span className="absolute bottom-2 left-2 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-background-50">
          {comic.genre}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700">
          {comic.title}
        </h3>
        <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-600">{comic.desc}</p>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs font-medium text-foreground-500">
            更新至 <span className="text-foreground-700">{comic.chapter}</span>
          </span>
          <span className="text-xs text-foreground-400">{comic.updateTime}</span>
        </div>
      </div>
    </article>
  );
}